import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IUserOwnTractorFilter } from '../../constants/filter/userOwnTractorFilter.constant';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { createSearchParamBySelectedFilterOption } from '../../utils/filter/createSearchParamBySelectedFilterOption.util';
import { useAppSelector } from '../store/useStore';

export const useUpdatePokingListPageSearchParam = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const userOwnTractorFilterStates = useAppSelector((state) => state.filter.userOwnTractorFilter);

  useEffect(() => {
    if (userOwnTractorFilterStates.isSearchParamChecked && userOwnTractorFilterStates.globalFilters) {
      const existingParams = Object.fromEntries(searchParams.entries());

      const newFilterParams = createSearchParamBySelectedFilterOption({
        filterType: 'userOwnTractorFilter',
        filters: userOwnTractorFilterStates.globalFilters as IUserOwnTractorFilter[],
      });

      const mergedParams = {
        ...existingParams,
        ...newFilterParams,
      };

      const newSearchParams = new URLSearchParams(mergedParams).toString();

      navigate(`${pageInfo.tractorPokingListPage.path}?${newSearchParams}`, {
        replace: true,
      });
    }
  }, [userOwnTractorFilterStates.isSearchParamChecked, userOwnTractorFilterStates.globalFilters]);
};
